// activityNewUser6
export default {
  routerTitle: '盈寶新人禮',
  shareTitle: '盈寶新人禮 獎金高達2900HKD',
  shareDesc: '獎勵升級 千元禮包等你拿',

  or: '或',
  award: '獎',
  awardAgain: '再獎',
  awardAgain2: '可獲獎勵共',
  cashCoupons: '現金券',

  cardOneLabel1: '註冊送行情',
  cardOneValue11: '內地客戶送30天港股LV2行情券',
  cardOneValue12: '完成美股非專業訂戶問卷送30天美股LV1行情',
  cardOneDesc1: '註：香港及海外地區送港股LV1行情',
  cardOneLabel2: '開戶送 HKD 2256 禮包',
  cardOneValue21: '30天港股LV2串流報價行情',
  cardOneValue22: '完成美股非專業訂戶問卷送30天美股LV1行情',
  cardOneDesc2: '註：香港及海外地區港股送30天LV1行情，美股送30天美股LV1行情',

  cardTwoTitle: '首次入金2萬(或等值)以上最高贈送 HKD 600 禮包',
  cardTwoTable1: '首次入金 HKD 20,000 - 299,999(或等值)',
  cardTwoTable1Row: '30天內無出金且成交股票一次',
  cardTwoTable2: '首次入金 HKD 20,000 - 299,999(或等值)',
  cardTwoTable2Row: '60天內無出金且成交股票一次',
  cardTwoTable3: '首次入金 HKD 20,000 - 299,999(或等值)',
  cardTwoTable3Row: '90天內無出金且成交股票一次',

  cardThreeTitle: '首次入金30萬(或等值)以上最高贈送 HKD 2900 禮包',
  cardThreeTable1: '首次入金 HKD 30萬(或等值) 以上',
  cardThreeTable1Row1: '30天內無出金且成交股票一次',
  cardThreeTable2: '交易額達標獎勵',
  cardThreeTable2Row11: '30天內無出金',
  cardThreeTable2Row12: '且交易額達到150萬(或等值)',
  cardThreeTable2Row21: '60天內無出金',
  cardThreeTable2Row22: '且交易額達到300萬(或等值)',
  cardThreeTable2Row31: '90天內無出金',
  cardThreeTable2Row32: '且交易額達到450萬(或等值)',

  pageTips: '注：首次入金2萬獎勵和首次入金30萬獎勵只能參與一個。'
}
